import React, { Component } from "react";
import axios from "axios";
import { message, Table, Space, Modal, Button, Input } from "antd";
import moment from "moment";
import ClienteDetail from "./Clients/ClienteDetail";

import Scontrino from './Scontrino';

const { Search } = Input;


export default class Transazioni extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactions: [],
      client: "",
      visible: false,
      pagination: {
        current: 1,
        pageSize: 100,
      },
      loading: false
    };

    this.checkUserOfCard = this.checkUserOfCard.bind(this);

    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.showModal = this.showModal.bind(this);

    this.updateCliente = this.updateCliente.bind(this);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.onSearch = this.onSearch.bind(this)
  }

  componentDidMount() {
    this.fetchTransactions();
  }

  fetchTotalTransactions() {
    axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/clienti/GetTransactionsCount`
      )
      .then((response) => {
        let new_pagination = { ...this.state.pagination };
        new_pagination.total = response.data;

        this.setState({ pagination: new_pagination });
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  }


  fetchTransaction(_id) {
    axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/transactions/GetById?_id=${_id}`
      )
      .then((response) => {
        console.log(response.data)


        if (response.data.found === true) {
          this.setState({ notFound: false, transactions: [response.data] });
        } else {
          this.setState({ notFound: true, transactions: [] });
        }
        // console.log(response.data.hits);
        // handle success
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
        this.setState({ loading: false })
        console.log(this.state.transactions);
      });
  }


  fetchTransactions() {

    this.setState({ loading: true })

    this.fetchTotalTransactions();

    let calculated_from = 0;

    if (this.state.pagination.current === 1) {
      calculated_from = 0;
      // from = 0
    } else {
      // from = *100
      calculated_from =
        (this.state.pagination.current -1) * this.state.pagination.pageSize;
    }

    axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/clienti/GetAllTransactions?from=${calculated_from}&size=${this.state.pagination.pageSize}`
      )
      .then((response) => {
        // console.log(response.data.hits);
        // handle success
        this.setState({ notFound: false, transactions: response.data.hits });
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
        this.setState({ loading: false })
        console.log(this.state.transactions);
      });
  }

  checkUserOfCard(cardId) {
    console.log(cardId);

    // fetch details about the client

    this.setState({ client: null }, () => {
      this.fetchOneCliente(cardId);
    })
  }





  fetchOneCliente(id) {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/clienti/GetById?id=${id}`)
      .then((response) => {

        console.log(response.data.hits[0]._source);

        this.setState({ client: response.data.hits[0] }, () => {
          console.log(this.state.client)


          this.showModal();
        });
        // handle success
      })
      .catch((error) => {
        console.log("we are handling the error here")

        message.error("Siamo spiacenti, la carta in questione non e' stata trovato nel database nostro")
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ pagination }, () => {
      this.fetchTransactions();
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  onSearch(value) {
    if (value === "") {
      console.log("it's empty")
      this.fetchTransactions();
    }

    if (value !== "") {
      this.fetchTransaction(value);
    }
  }

  renderScontrino(scontrini) {
    if (scontrini.length === 0) {
      return <b>Non abbiamo informazioni su questo scontrino</b>

    }

    return scontrini.map((scontrino) => (
      <Scontrino key={scontrino.productId} scontrino={scontrino} />
    ));
  }


  updateCliente(client) {

    this.setState({ clienteSelected: client }, () => {

      axios
        .put(
          `${process.env.REACT_APP_SERVER_URL}/api/clienti?id=${this.state.client._id}`,
          this.state.client._source
        )
        .then(
          (response) => {

            if (response.status === 200) {
              message.success("cliente aggiornato con successo");
              this.setState({ visible: false });
            }
          },
          (error) => {
            message.error("errore nell'aggiornamento del cliente");
          }
        )
    })
  }


  render() {
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{tx._id}</p>
          </Space>
        ),
      },

      {
        title: "Data",
        dataIndex: "data",
        key: "data",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{moment(tx._source.dateTime).format("DD-MM-YYYY hh:mm")}</p>
          </Space>
        ),
      },
      {
        title: "Carta",
        dataIndex: "carta",
        key: "carta",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <Button onClick={() => this.checkUserOfCard(tx._source.cardId)}>
              {tx._source.cardId}
            </Button>
          </Space>
        ),
      },

      {
        title: "Punti",
        dataIndex: "punti",
        key: "punti",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{tx._source.punti}</p>
          </Space>
        ),
      },
    ];
    return (
      <div style={{ margin: "10%" }}>
        <div id="search_bar">
          <Search
            placeholder="Cerca una transazione"
            allowClear
            enterButton="Cerca"
            size="large"
            onSearch={this.onSearch}
          />
        </div>



        <Table
          rowKey={(tx) => tx._id}
          dataSource={this.state.transactions}
          columns={columns}
          size={"small"}
          bordered={true}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
          loading={this.state.loading}
          expandable={{
            expandedRowRender: (tx) =>
              this.renderScontrino(tx._source.scontrino),
            onExpand: (expanded, record) => console.log(record),
            rowExpandable: (tx) => tx._source.cardId !== "Not Expandable",
          }}
        />

        <Modal
          title="Visualizzazione del cliente"
          visible={this.state.visible}
          onOk={this.handleOk}
          width={1300}
          onCancel={this.handleCancel}
        >
          <ClienteDetail key={Math.random()} cliente={this.state.client} role={this.props.role} clientAction={this.updateCliente} />
        </Modal>
      </div>
    );
  }
}
